<template>
  <v-data-table
    :headers="headers"
    :items="listado"
    :items-per-page="20">
    <template v-slot:[`item.numero`]="{ item }">
      <router-link
          :to="{ name: 'consultasContratoDefault', params: { idContrato: item.id } }"
        >
          <strong>
            {{ item.numero }}
          </strong>
        </router-link>
    </template>
    <template v-slot:[`item.tipoDeObra`]="{ item }">
      <template
        v-if="item.obra">
        <v-chip
          small
          :color="item.obra.obra.tipo.color">
          {{ item.obra.obra.tipo.descripcion }}
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.meta`]="{ item }">
      <cortar-texto
        :texto="item.meta">
      </cortar-texto>
    </template>
    <template v-slot:[`item.fecha`]="{ item }">
      {{ new Date(`${item.fecha}T00:00:00`).toLocaleDateString() }}
    </template>
    <template v-slot:[`item.total`]="{ item }">
      <template
        v-if="item.modificado.total <= 0">
        {{ (item.total) | currency }}
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ (item.total + item.modificado.total) | currency }}
        </span>
      </template>
    </template>
    <template v-slot:[`item.totalAnticipo`]="{ item }">
      {{ item.totalAnticipo | currency }}
    </template>
    <template v-slot:[`item.supervisionExterna`]="{ item }">
      <template
        v-if="item.supervisionExterna">
        {{ item.supervisionExterna.contratoRelacionado.contratista.nombreRazonSocial }}
      </template>
    </template>
    <template v-slot:[`item.fechaInicio`]="{ item }">
      <template
        v-if="!item.modificado.fechaInicio">
        <span
          class="base1--text font-weight-medium">
          {{ new Date(`${item.fechaInicio}T00:00:00`).toLocaleDateString() }}
        </span>
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ new Date(`${item.modificado.fechaInicio}T00:00:00`).toLocaleDateString() }}
        </span>
      </template>
    </template>
    <template v-slot:[`item.fechaTermino`]="{ item }">
      <template
        v-if="!item.modificado.fechaTermino">
        <span
          class="base1--text font-weight-medium">
          {{ new Date(`${item.fechaTermino}T00:00:00`).toLocaleDateString() }}
        </span>
      </template>
      <template
        v-else>
        <span
          class="error--text font-weight-medium">
          {{ new Date(`${item.modificado.fechaTermino}T00:00:00`).toLocaleDateString() }}
        </span>
      </template>
    </template>
    <template v-slot:[`item.avanceProgramado`]="{ item }">
      <template
        v-if="item.avanceProgramado.porcentaje">
        <v-chip
          small
          color="naranja2">
          {{ item.avanceProgramado.porcentaje }}%
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.avanceFisico`]="{ item }">
      <template
        v-if="item.ultimoReporte">
        <v-chip
          small
          color="azul1">
          {{ item.ultimoReporte.avanceFisico }}%
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.avanceFinanciero`]="{ item }">
      <template
        v-if="item.ultimoReporte">
        <v-chip
          small
          color="verde1">
          {{ item.ultimoReporte.avanceFinanciero }}%
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.estatus`]="{ item }">
      <template
        v-if="item.ultimoReporte">
        <v-chip
          small
          :color="colorEstatus(item.avanceDiferencia)"
          :dark="colorEstatus(item.avanceDiferencia) === 'red darken-2'">
          <template
            v-if="item.avanceDiferencia < 0">
            {{ dosDigitos((item.avanceDiferencia * -1)) }}%
          </template>
          <template
            v-else>
            {{ dosDigitos(item.avanceDiferencia) }}%
          </template>
        </v-chip>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'DesktopListadoReporteConsulta',
  components: {
    CortarTexto,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Número',
          align: 'start',
          sortable: false,
          value: 'numero',
        },
        { text: 'Tipo', value: 'tipoDeObra', sortable: false },
        { text: 'Meta', value: 'meta', sortable: false },
        {
          text: 'Contratista', value: 'contratista.nombreRazonSocial', sortable: false,
        },
        {
          text: 'Fecha', value: 'fecha', align: 'center', sortable: false,
        },
        {
          text: 'Contratado', value: 'total', align: 'end', sortable: false,
        },
        {
          text: 'Anticipo', value: 'totalAnticipo', align: 'end', sortable: false,
        },
        {
          text: 'Supr. Externa', value: 'supervisionExterna', sortable: true,
        },
        {
          text: 'F. Inicio', value: 'fechaInicio', align: 'center', sortable: false,
        },
        {
          text: 'F. Término', value: 'fechaTermino', align: 'center', sortable: false,
        },
        {
          text: 'Av. Prog.', value: 'avanceProgramado', align: 'center', sortable: false,
        },
        {
          text: 'Av. Fisico', value: 'avanceFisico', align: 'center', sortable: false,
        },
        {
          text: 'Av. Finan.', value: 'avanceFinanciero', align: 'center', sortable: false,
        },
        {
          text: 'Atraso', value: 'estatus', align: 'center', sortable: true,
        },
      ],
    };
  },
  methods: {
    colorEstatus(avanceDiferencia) {
      if (avanceDiferencia <= 5) return 'success';
      if (avanceDiferencia > 5 && avanceDiferencia <= 25) return 'yellow darken-2';
      if (avanceDiferencia > 25) return 'red darken-2';
      return 'success';
    },
    dosDigitos(num, decimals) {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: decimals || 2,
        maximumFractionDigits: decimals || 2,
      });
    },
  },
};
</script>

<style lang="scss">

</style>
